import { Controller } from '@hotwired/stimulus';

export default class LemonwayIframeController extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String,
  };

  connect() {
    this.syncModal = new bootstrap.Modal(
      document.getElementById('syncModal'),
      { backdrop: 'static', keyboard: false }
    )
    this.initWidget()
  }

  initWidget() {
    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: 'fr',
        onMyAccount: () => this.redirectToNextStep(false, 4000),
        onFinish: () => this.redirectToNextStep(true, 1000),
        onPageChange: () => window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
    )
  }

  redirectToNextStep(success = false, delay = 0) {
    const url = new URL(this.redirectUrlValue)

    if (success) {
      url.searchParams.set('status', 'success')
    }

    this.syncModal.show()

    setTimeout(() => {
      window.location.replace(url)
    }, delay)
  }
}
